import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.memoryStepOneExtraCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.memoryStepOneExtraCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) =>
    state.memoryStepOneExtraCollections.data.memoryStepOneExtraCollections,
  (collections = []) => collections
);
const getGroupLabel = createSelector(
  (state) =>
    state.memoryStepOneExtraCollections.data.memoryStepOneExtraGroupLabel,
  (groupLabel = '') => groupLabel
);
const getPageCount = createSelector(
  (state) => state.memoryStepOneExtraCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getGroupLabel,
  getHasLoaded,
  getPageCount,
};
